const PACKAGE_OPTIONS = [
  { value: '326', label: '3d Laser Scanning Survey' },
  { value: '456', label: '3D Modelling' },
  { value: '228', label: 'Above Ground Drainage' },
  { value: '35', label: 'Abseilers / Rope Access' },
  { value: '201', label: 'Access Controls' },
  { value: '225', label: 'Access Hatches' },
  { value: '43', label: 'Access Platforms' },
  { value: '517', label: 'Acoustic / Air Barriers' },
  { value: '155', label: 'Acoustic Ceilings' },
  { value: '75', label: 'Acoustic Consultant' },
  { value: '50', label: 'Acoustic Enclosures' },
  { value: '435', label: 'Acoustic Flooring' },
  { value: '434', label: 'Acoustic Louvres' },
  { value: '136', label: 'Acoustic Panelling' },
  { value: '2389', label: 'Actuators and Rotork' },
  { value: '2390', label: 'Aeration System' },
  { value: '474', label: 'Aerial Photography' },
  { value: '487', label: 'Aerials / IRS' },
  { value: '2457', label: 'Agency Labour' },
  { value: '540', label: 'Aggregates' },
  { value: '202', label: 'Air Conditioning' },
  { value: '203', label: 'Air Source Heat Pumps' },
  { value: '447', label: 'Air Testing' },
  { value: '2464', label: 'Aircraft Warning Lights' },
  { value: '541', label: 'Aluminium Capping' },
  { value: '564', label: 'Aluminium Cladding' },
  { value: '93', label: 'Aluminium Doors' },
  { value: '436', label: 'Aluminium Windows' },
  { value: '137', label: 'Appliances' },
  { value: '568', label: 'Approved Inspector' },
  { value: '2621', label: 'Arcade Games Installation' },
  { value: '2386', label: 'Archaeologist' },
  { value: '76', label: 'Architect' },
  { value: '264', label: 'Architectural / Bespoke Stairs' },
  { value: '303', label: 'Architectural Glazing / Glass' },
  { value: '138', label: 'Architectural Hardware' },
  { value: '273', label: 'Architectural Metalwork / Steelwork' },
  { value: '472', label: 'Architectural Photography' },
  { value: '65', label: 'Architectural Precast Concrete' },
  { value: '285', label: 'Art work / Murals / Trompe L Oeil' },
  { value: '342', label: 'Asbestos Encapsulation' },
  { value: '87', label: 'Asbestos Removal' },
  { value: '77', label: 'Asbestos Surveyor' },
  { value: '249', label: 'Asphalt Roofing' },
  { value: '2652', label: 'Attenuation' },
  { value: '204', label: 'Audio Visual' },
  { value: '2370', label: 'Auto Louvre' },
  { value: '94', label: 'Automated Doors' },
  { value: '95', label: 'Automatic Gates' },
  { value: '226', label: 'Automatic Opening Vents (AOV)' },
  { value: '2640', label: 'Bar' },
  { value: '2625', label: 'Bar Construction' },
  { value: '432', label: 'Basement Conversion' },
  { value: '179', label: 'Basements' },
  { value: '526', label: 'Bat Surveys' },
  { value: '139', label: 'Bathrooms' },
  { value: '180', label: 'Below Ground Drainage' },
  { value: '296', label: 'Bespoke Architectural Timber Structures' },
  { value: '96', label: 'Bespoke Gates' },
  { value: '167', label: 'Bespoke Glazing / Glass' },
  { value: '274', label: 'Bespoke Metalwork / Steelwork' },
  { value: '260', label: 'Bespoke Signage' },
  { value: '97', label: 'Bi-folding Doors' },
  { value: '552', label: 'Bicycle/Bike Rack' },
  { value: '455', label: 'BIM Consultant' },
  { value: '205', label: 'Biomass' },
  { value: '115', label: 'Bird Control / Protection' },
  { value: '410', label: 'Bird Deterrent / Control' },
  { value: '515', label: 'Blind Automation' },
  { value: '514', label: 'Blind Controls' },
  { value: '486', label: 'Blinds' },
  { value: '470', label: 'Block and Beam' },
  { value: '2391', label: 'Blowers & Compressors' },
  { value: '556', label: 'Blue Roofing' },
  { value: '36', label: 'BMU Providers' },
  { value: '493', label: 'Boiler Services' },
  { value: '61', label: 'Brick / Facade Cleaning' },
  { value: '233', label: 'Brick / Structural Repairs' },
  { value: '2676', label: 'Brick and Stonework' },
  { value: '325', label: 'Brick Slips' },
  { value: '196', label: 'Brick Work / Block Work' },
  { value: '2415', label: 'Bridge Scrapers' },
  { value: '281', label: 'Bridges' },
  { value: '51', label: 'Brise Soleil' },
  { value: '2678', label: 'BSR Advisor' },
  { value: '2711', label: 'Builders Clean' },
  { value: '538', label: 'Builderswork Contractor' },
  { value: '444', label: 'Building Contols' },
  { value: '2612', label: 'Building Control' },
  { value: '206', label: 'Building Management Systems (BMS)' },
  { value: '560', label: 'Building Materials' },
  { value: '504', label: 'Building Services Engineer' },
  { value: '327', label: 'Building Surveyor' },
  { value: '2474', label: 'Bulk Earthworks' },
  { value: '2382', label: 'Cabinetry' },
  { value: '507', label: 'CAD Technician' },
  { value: '116', label: 'Canopies' },
  { value: '415', label: 'Carpentry - First Fix' },
  { value: '416', label: 'Carpentry - Second Fix' },
  { value: '156', label: 'Carpeting' },
  { value: '413', label: 'Casement Window' },
  { value: '275', label: 'Cast Iron' },
  { value: '489', label: 'Cast Stone' },
  { value: '2639', label: 'Catering' },
  { value: '2620', label: 'Catering Equipment' },
  { value: '2425', label: 'Cathodic Protection' },
  { value: '482', label: 'Cavity Wall and Insulation Extraction' },
  { value: '343', label: 'Cavity Wall Insulation' },
  { value: '2435', label: 'CCTV Survey' },
  { value: '379', label: 'CDM Services and Planning' },
  { value: '110', label: 'Ceilings' },
  { value: '2709', label: 'Ceramic Tiling' },
  { value: '2426', label: 'Cermamic Membranes' },
  { value: '2392', label: 'Chemical Dosing Equipment' },
  { value: '207', label: 'Chimneys / Flues' },
  { value: '2458', label: 'Civils Works' },
  { value: '49', label: 'Cladding / Facades / Envelope' },
  { value: '234', label: 'Cladding Paint Repairs' },
  { value: '2410', label: 'Clean Water End Suction' },
  { value: '2409', label: 'Clean Water Split Casing Pumps' },
  { value: '2401', label: 'Cleaning - Welfare' },
  { value: '2399', label: 'Cleaning/Emptying/Disinfection' },
  { value: '2412', label: 'Coagulation' },
  { value: '208', label: 'Combined Heat and Power (CHP)' },
  { value: '2462', label: 'Combined Sewer Overflow Screens' },
  { value: '328', label: 'Commercial Management' },
  { value: '2669', label: 'Commissioning' },
  { value: '98', label: 'Composite Doors' },
  { value: '437', label: 'Composite Windows' },
  { value: '2650', label: 'Concrete Placing' },
  { value: '66', label: 'Concrete Pumping' },
  { value: '67', label: 'Concrete Repairs' },
  { value: '2443', label: 'Concrete Testing' },
  { value: '2459', label: 'Concrete Waterproofing' },
  { value: '522', label: 'Construction Flags' },
  { value: '473', label: 'Construction Photography' },
  { value: '2387', label: 'Contaminated Ground Remediation' },
  { value: '181', label: 'Contiguous Piling' },
  { value: '505', label: 'Continuous Flight Auger (CFA) Piling' },
  { value: '157', label: 'Contract Flooring' },
  { value: '2460', label: 'Contract Staff' },
  { value: '37', label: 'Crane Hire' },
  { value: '2656', label: 'Crane Operator' },
  { value: '488', label: 'Curtains' },
  { value: '2690', label: 'Damp & Moisture surveys' },
  { value: '300', label: 'Damp Proofing' },
  { value: '2619', label: 'Darts Technology' },
  { value: '209', label: 'Data' },
  { value: '336', label: 'Decking' },
  { value: '2715', label: 'Decorations' },
  { value: '418', label: 'Decorative Surfacing' },
  { value: '88', label: 'Demolition / Strip out' },
  { value: '2677', label: 'Design Coordinator' },
  { value: '89', label: 'Diamond Drilling / Cutting' },
  { value: '348', label: 'Diffusers' },
  { value: '2461', label: 'Directional Drilling' },
  { value: '90', label: 'Disposal / Waste Removal' },
  { value: '329', label: 'Dispute Management' },
  { value: '2436', label: 'Dive Survey' },
  { value: '2463', label: 'Diving' },
  { value: '210', label: 'Door Entry' },
  { value: '235', label: 'Door Refurbishment / Stripping' },
  { value: '2689', label: 'Door Undercuts/Modifications' },
  { value: '400', label: 'Drainage and Service Ducts' },
  { value: '229', label: 'Drainage Cleaning' },
  { value: '465', label: 'Draughtsman / Designer' },
  { value: '2414', label: 'Drinking Water Inspectorate' },
  { value: '182', label: 'Driven / Displacement Pile' },
  { value: '419', label: 'Driveways' },
  { value: '471', label: 'Drone Photography' },
  { value: '2675', label: 'Dry Lining, Plastering & Screed' },
  { value: '131', label: 'Dry Riser / Wet Riser' },
  { value: '460', label: 'Dry Stone Walling' },
  { value: '111', label: 'Dry-Lining' },
  { value: '211', label: 'Ductwork' },
  { value: '523', label: 'Ecological Appraisals' },
  { value: '2393', label: 'Electric Actuators' },
  { value: '222', label: 'Electric Underfloor Heating' },
  { value: '534', label: 'Electric Vehicle Charging' },
  { value: '212', label: 'Electrical Contractor' },
  { value: '2396', label: 'Electrical HV/LV Installation/Survey' },
  { value: '2397', label: 'Electrical Installation - Temporary Welfare' },
  { value: '2380', label: 'Electrical Mains Installations' },
  { value: '533', label: 'Electrical Vehicle Charging Points' },
  { value: '354', label: 'Electrostatic Air Cleaners' },
  { value: '551', label: 'Enabling Works' },
  { value: '213', label: 'Entertainment / Cinema' },
  { value: '158', label: 'Entrance Matting' },
  { value: '2437', label: 'Environmental/Ecological Survey' },
  { value: '191', label: 'Escalators / Travellators' },
  { value: '168', label: 'ETFE Systems' },
  { value: '183', label: 'Excavation' },
  { value: '2702', label: 'Expansion Joints (Highways + Buildings)' },
  { value: '431', label: 'Extensions' },
  { value: '2372', label: 'External Green Screen' },
  { value: '344', label: 'External Wall Insulation' },
  { value: '411', label: 'Fabric Cladding Systems' },
  { value: '236', label: 'Facade Repairs / Restoration' },
  { value: '2699', label: 'Facilities Management (FM)' },
  { value: '38', label: 'Fall Restraint / Fall Arrest' },
  { value: '508', label: 'Falsework / Temporary Works' },
  { value: '349', label: 'Fan Filter Units' },
  { value: '350', label: 'Fancoils' },
  { value: '2686', label: 'Fascia & Soffit Boarding' },
  { value: '2685', label: 'Façade Designer' },
  { value: '117', label: 'Fencing' },
  { value: '286', label: 'Fibrous Plaster' },
  { value: '2628', label: 'Finance' },
  { value: '130', label: 'Fire' },
  { value: '351', label: 'Fire and Smoke Dampers' },
  { value: '2613', label: 'Fire Consultant' },
  { value: '132', label: 'Fire Detection / Alarm' },
  { value: '99', label: 'Fire Doors' },
  { value: '140', label: 'Fire Places / Surrounds' },
  { value: '133', label: 'Fire Proofing / Passive Fire Protection' },
  { value: '555', label: 'Fire Rated Glazing' },
  { value: '566', label: 'Fire Safety Consultant' },
  { value: '516', label: 'Fire Stopping / Fire Barriers' },
  { value: '2394', label: 'Fixed Standby Generators' },
  { value: '337', label: 'Flood Water Management' },
  { value: '287', label: 'Floor and Wall Tiling' },
  { value: '2697', label: 'Floor Painting & Sealing' },
  { value: '237', label: 'Floor Sanding' },
  { value: '2708', label: 'Flooring' },
  { value: '2644', label: 'Flooring Fitters' },
  { value: '2645', label: 'Flooring Suppliers' },
  { value: '2662', label: 'Flushing Contractor' },
  { value: '427', label: 'Food Lift / Dumb Waiter' },
  { value: '452', label: 'Forecourt Structures' },
  { value: '2654', label: 'Forklift' },
  { value: '2659', label: 'Forklift / Forklift Driver' },
  { value: '510', label: 'Formwork' },
  { value: '2472', label: 'Formwork, Reinforcement and Concrete' },
  { value: '230', label: 'Foul Drainage Pump Systems' },
  { value: '184', label: 'Foundations' },
  { value: '238', label: 'French Polishing' },
  { value: '141', label: 'Furniture' },
  { value: '2649', label: 'Gabions' },
  { value: '2638', label: 'Games' },
  { value: '39', label: 'Gantries / Walkways' },
  { value: '100', label: 'Garage Doors' },
  { value: '2373', label: 'Garden Furniture' },
  { value: '2615', label: 'Garden Supplies' },
  { value: '476', label: 'Gas Membranes' },
  { value: '491', label: 'Gas Services' },
  { value: '477', label: 'Gas Verification Company' },
  { value: '2701', label: 'General Builders Merchants' },
  { value: '78', label: 'Geotechnical / Environmental' },
  { value: '169', label: 'Glass Balconies' },
  { value: '265', label: 'Glass Balustrades / Handrails' },
  { value: '2411', label: 'Glass Fused Steel Tanks' },
  { value: '142', label: 'Glass Partitions' },
  { value: '239', label: 'Glass Repairs' },
  { value: '2674', label: 'Glazing and Curtain Walling' },
  { value: '426', label: 'Goods Lift' },
  { value: '2627', label: 'Graphics' },
  { value: '52', label: 'GRC Cladding' },
  { value: '483', label: 'Green Energy Consultant' },
  { value: '250', label: 'Green Roofing' },
  { value: '338', label: 'Green Technologies' },
  { value: '554', label: 'Green Wall' },
  { value: '352', label: 'Grilles' },
  { value: '2400', label: 'Grit Removal' },
  { value: '524', label: 'Ground Contamination Surveys' },
  { value: '478', label: 'Ground Gas Training Seminars' },
  { value: '2475', label: 'Ground Improvement' },
  { value: '2433', label: 'Ground Investigations' },
  { value: '214', label: 'Ground Source Heat Pumps' },
  { value: '185', label: 'Ground Work' },
  { value: '251', label: 'GRP / Fibreglass' },
  { value: '412', label: 'GRP Cladding' },
  { value: '2451', label: 'GRP Enclosures and Kiosks' },
  { value: '282', label: 'GRP Structures' },
  { value: '40', label: 'Guardrails / Edge Protection' },
  { value: '252', label: 'Guttering/Rainwater Goods' },
  { value: '118', label: 'Hard Landscaping' },
  { value: '2438', label: 'Harmonic Survey' },
  { value: '79', label: 'Health and Safety Consultant' },
  { value: '261', label: 'Health and Safety Signs' },
  { value: '2696', label: 'Healthcare / Hospital Furniture' },
  { value: '445', label: 'Heating Controls' },
  { value: '353', label: 'Heating Solutions' },
  { value: '2643', label: 'High-End Retail' },
  { value: '2452', label: 'Hire of Operated Plant' },
  { value: '462', label: 'Historic Building Restoration' },
  { value: '521', label: 'Hoarding / Hoarding Graphics' },
  { value: '2665', label: 'Hot Tapping' },
  { value: '573', label: 'HV/LV Supply & Distribution' },
  { value: '420', label: 'HVAC - Heat Recovery Systems' },
  { value: '423', label: 'Hydraulic Lifts' },
  { value: '2480', label: 'Hydrodemolition' },
  { value: '2618', label: 'Hygiene and Infection Prevention Solutions' },
  { value: '2366', label: 'Hygienic Doors' },
  { value: '449', label: 'Hygienic Wall Cladding' },
  { value: '2624', label: 'Ice Cream Machines' },
  { value: '262', label: 'Illuminated Signs' },
  { value: '571', label: 'Independent Connection Provider (ICP)' },
  { value: '479', label: 'Independent Material Testing' },
  { value: '101', label: 'Industrial / Roller Doors' },
  { value: '2664', label: 'Industrial Machine Moving Specialists' },
  { value: '2691', label: 'Industrial Painting / Heavy-Duty Coatings' },
  { value: '2413', label: 'Inlet Screens and Screenings Handling' },
  { value: '68', label: 'Insitu Concrete' },
  { value: '2395', label: 'Instrumentation' },
  { value: '2694', label: 'Insulated Concrete Formwork (ICF)' },
  { value: '2660', label: 'Insulation Engineer' },
  { value: '2614', label: 'Interior Designer' },
  { value: '112', label: 'Internal Partitions' },
  { value: '417', label: 'Intumescent Coating' },
  { value: '525', label: 'Invasive Plant Species Management' },
  { value: '2402', label: 'Invasive Species Removal' },
  { value: '2368', label: 'IPS Toilet Panels' },
  { value: '143', label: 'Ironmongery' },
  { value: '119', label: 'Irrigation Systems' },
  { value: '144', label: 'Joinery' },
  { value: '2634', label: 'Kitchen Supplies' },
  { value: '145', label: 'Kitchens' },
  { value: '480', label: 'Labour Agency' },
  { value: '41', label: 'Ladders' },
  { value: '215', label: 'Lagging / Thermal Insulation' },
  { value: '2637', label: 'Lamella Systems' },
  { value: '330', label: 'Land Surveys' },
  { value: '120', label: 'Landscape Design' },
  { value: '2442', label: 'Laser/Drone Survey' },
  { value: '113', label: 'Lath and Plaster' },
  { value: '240', label: 'Lead Paint Removal' },
  { value: '253', label: 'Lead Roofing' },
  { value: '2646', label: 'Leisure Specialist' },
  { value: '91', label: 'Lift Removal' },
  { value: '2657', label: 'Lifting Equipment Placing' },
  { value: '192', label: 'Lifts' },
  { value: '216', label: 'Lighting' },
  { value: '217', label: 'Lightning Protection' },
  { value: '459', label: 'Lime Mortar Pointing' },
  { value: '2371', label: 'Lime Plastering' },
  { value: '2388', label: 'Linen Chute' },
  { value: '561', label: 'Lintels' },
  { value: '254', label: 'Liquid Applied Waterproofing' },
  { value: '509', label: 'Load Bearing Piling' },
  { value: '2623', label: 'Locksmith' },
  { value: '429', label: 'Loft Conversions' },
  { value: '2688', label: 'Loft Insulation' },
  { value: '569', label: 'Logistics Planner' },
  { value: '2444', label: 'LOLAR Testing' },
  { value: '53', label: 'Louvres' },
  { value: '2632', label: 'Luxury Display Contractor' },
  { value: '2439', label: 'M&E Equipment Survey' },
  { value: '2655', label: 'Magic Man' },
  { value: '2374', label: 'Making Good' },
  { value: '288', label: 'Marble' },
  { value: '461', label: 'Masonry Construction' },
  { value: '42', label: 'Mast climbers' },
  { value: '475', label: 'Mast Photography' },
  { value: '2714', label: 'Mastic' },
  { value: '331', label: 'Measured Building Survey' },
  { value: '218', label: 'Mechanical and Electrical Contractor' },
  { value: '80', label: 'Mechanical and Electrical Engineer' },
  { value: '531', label: 'Mechanical Contractor' },
  { value: '2478', label: 'Media Removal/Replacement' },
  { value: '2427', label: 'MEICA Design' },
  { value: '276', label: 'Metal Decking' },
  { value: '241', label: 'Metal Polishing' },
  { value: '255', label: 'Metal Roofing' },
  { value: '446', label: 'Metering Management Services' },
  { value: '464', label: 'Mezzanine Floors' },
  { value: '186', label: 'Mini Piling' },
  { value: '170', label: 'Mirrors' },
  { value: '2695', label: 'Modular / Volumetric Construction' },
  { value: '2404', label: 'Modular Pumping Stations' },
  { value: '289', label: 'Mosaic Tiling' },
  { value: '2405', label: 'Motor Control Centre & Systems Integration' },
  {
    value: '2406',
    label: 'Motor Control Centre, Systems Integration and PLC/SCADA',
  },
  { value: '513', label: 'Motorised Blinds' },
  { value: '397', label: 'Motorway Communications' },
  { value: '539', label: 'Muck Away' },
  { value: '2369', label: 'Multi-Trade Contractor' },
  { value: '2407', label: 'Nano Filtration Membrane' },
  { value: '2661', label: 'NDT Technician' },
  { value: '2398', label: 'Network Monitoring' },
  { value: '2417', label: 'Nitrifying Trickling Filters' },
  { value: '2440', label: 'Noise Survey' },
  { value: '2693', label: 'Noise, Vibration & Dust (NVD) Monitoring' },
  { value: '2403', label: 'Odour Control' },
  { value: '2476', label: 'Odour Control & Removal' },
  { value: '2629', label: 'Office Furniture' },
  { value: '2631', label: 'Office Landlords' },
  { value: '2622', label: 'Office Supplies' },
  { value: '506', label: 'Open Augered Piling' },
  { value: '404', label: 'Operation and Maintenance Manuals' },
  { value: '2375', label: 'Outdoor Kitchen' },
  { value: '2428', label: 'Overpumping' },
  { value: '562', label: 'Padstones' },
  { value: '2713', label: 'Painting & Decorating' },
  { value: '2710', label: 'Painting & Decs' },
  { value: '290', label: 'Painting / Decorating' },
  { value: '450', label: 'Parquet Flooring' },
  { value: '399', label: 'Pavements' },
  { value: '121', label: 'Paving' },
  { value: '390', label: 'Pedestrian Guardrails' },
  { value: '2377', label: 'Pergola' },
  { value: '62', label: 'Pest Control' },
  { value: '574', label: 'Pharmaceutical Cleanrooms' },
  { value: '219', label: 'Photovoltaic (PV) Panels' },
  { value: '2671', label: 'Pipe Installation' },
  { value: '2666', label: 'Pipefreezing' },
  { value: '332', label: 'Planning and Neighbouring Applications' },
  { value: '333', label: 'Planning and Programming' },
  { value: '2611', label: 'Planning Consultant' },
  { value: '122', label: 'Planters' },
  { value: '291', label: 'Plastering' },
  { value: '2449', label: 'Plate Bearing Tests' },
  { value: '424', label: 'Platform Lifts' },
  { value: '123', label: 'Play Areas' },
  { value: '220', label: 'Plumbing and Heating' },
  { value: '2667', label: 'Pocket and Flow Meter Insertion' },
  { value: '159', label: 'Polished Concrete Flooring' },
  { value: '292', label: 'Polished Plaster' },
  { value: '345', label: 'Polyurea Roof Coatings' },
  { value: '563', label: 'Posi Joists' },
  { value: '2477', label: 'Potable water supply' },
  { value: '81', label: 'PQS / Quantity Surveyors' },
  { value: '54', label: 'Precast Concrete Cladding' },
  { value: '69', label: 'Precast Concrete Drainage' },
  { value: '70', label: 'Precast Concrete Flooring' },
  { value: '469', label: 'Precast Concrete Insulated Flooring' },
  { value: '71', label: 'Precast Concrete Lift Shafts' },
  { value: '266', label: 'Precast Concrete Stairs' },
  { value: '72', label: 'Precast Concrete Structures' },
  { value: '2670', label: 'Precision Engineers' },
  { value: '2465', label: 'Prefabricated Utility Cupboards' },
  { value: '2500', label: 'Pressurisation' },
  { value: '457', label: 'Principal / Main Contractor' },
  { value: '567', label: 'Principle Designer' },
  { value: '2630', label: 'Printing' },
  { value: '82', label: 'Project Managers' },
  { value: '242', label: 'Protective Coatings' },
  { value: '2408', label: 'Provision of Flow Gauging' },
  { value: '231', label: 'Pump Systems' },
  { value: '467', label: 'Radiators' },
  { value: '2698', label: 'Radon Barrier Installation' },
  { value: '55', label: 'Rainscreen Cladding' },
  { value: '160', label: 'Raised Access Flooring' },
  { value: '2680', label: 'RC Wall' },
  { value: '2617', label: 'Refrigeration / Coldrooms' },
  { value: '430', label: 'Refurbishment / Fit Out' },
  { value: '293', label: 'Render' },
  { value: '197', label: 'Repointing' },
  { value: '161', label: 'Resin Flooring' },
  { value: '102', label: 'Revolving Doors' },
  { value: '2681', label: 'Road Markings / White Lining' },
  { value: '391', label: 'Road Markings and Studs' },
  { value: '389', label: 'Road Surfacing' },
  { value: '2448', label: 'Rock Netting/Retaining Walls' },
  { value: '171', label: 'Roof Lantern' },
  { value: '297', label: 'Roof Trusses' },
  { value: '172', label: 'Rooflight' },
  { value: '2687', label: 'Roofline Works' },
  { value: '346', label: 'Room In A Roof Insulation' },
  {
    value: '2416',
    label: 'Rotating Circular and Travelling Rectangular Trickling Filters',
  },
  { value: '357', label: 'Roughcasting' },
  { value: '2376', label: 'Safe Installation' },
  { value: '453', label: 'Safe Removal' },
  { value: '392', label: 'Safety Barriers' },
  { value: '147', label: 'Sanitaryware' },
  { value: '421', label: 'SAP - Air Tightness Testing' },
  { value: '387', label: 'Sarnafill Roofing Systems' },
  { value: '414', label: 'Sash Windows' },
  { value: '44', label: 'Scaffold' },
  { value: '527', label: 'Screed Pump Hire' },
  { value: '162', label: 'Screeding' },
  { value: '2453', label: 'Screens and Screenings Handling' },
  { value: '565', label: 'Screw / Helical Piles' },
  { value: '187', label: 'Secant Piling' },
  { value: '173', label: 'Secondary Glazing' },
  { value: '356', label: 'Security' },
  { value: '221', label: 'Security / CCTV' },
  { value: '2455', label: 'Security Covers/Products/Fencing' },
  { value: '438', label: 'Security Doors' },
  { value: '124', label: 'Security Fencing' },
  { value: '103', label: 'Security Gates' },
  { value: '83', label: 'Setting Out / Site Survey' },
  { value: '188', label: 'Sheet Piling' },
  { value: '2616', label: 'Shelving' },
  { value: '148', label: 'Shop fitting' },
  { value: '2636', label: 'Shop Furniture' },
  { value: '56', label: 'Shopfronts' },
  { value: '243', label: 'Shot Blasting' },
  { value: '174', label: 'Shower Screens' },
  { value: '2633', label: 'Shuffle Boards' },
  { value: '2379', label: 'Shutters' },
  { value: '259', label: 'Signage' },
  { value: '301', label: 'Silicone / Mastic' },
  { value: '256', label: 'Single Ply / Flat Roofing' },
  { value: '2441', label: 'Site & Ground Investigation Survey / Trial Pits' },
  { value: '2473', label: 'Site Clearance' },
  { value: '481', label: 'Site Management' },
  { value: '2653', label: 'Skips' },
  { value: '257', label: 'Slate / Tile Roofing' },
  { value: '104', label: 'Sliding Doors' },
  { value: '2658', label: 'Slinger / Banksman' },
  { value: '2483', label: 'Sludge Dewatering' },
  { value: '2692', label: 'Soffit Insulation' },
  { value: '2716', label: 'Soft Flooring' },
  { value: '125', label: 'Soft Landscaping' },
  { value: '2447', label: 'Soil Anchors/Ground Stabilisation' },
  { value: '126', label: 'Solar Shading / Awnings' },
  { value: '63', label: 'Specialist Cleaners' },
  { value: '2385', label: 'Specialist Medical Equipment' },
  { value: '2647', label: 'Specialist Trades/Suppliers' },
  { value: '267', label: 'Spiral Stairs' },
  { value: '149', label: 'Splashbacks' },
  { value: '127', label: 'Sports Recreation Areas' },
  { value: '347', label: 'Spray Foam Insulation' },
  { value: '73', label: 'Sprayed Concrete' },
  { value: '134', label: 'Sprinkler System' },
  { value: '175', label: 'Stained Glass' },
  { value: '2454', label: 'Static Mixer' },
  { value: '492', label: 'Steam Services' },
  { value: '268', label: 'Steel / Metal Balustrades / Handrails' },
  { value: '269', label: 'Steel / Metal Stairs' },
  { value: '105', label: 'Steel Doors' },
  { value: '2466', label: 'Steel Fixing' },
  { value: '277', label: 'Steel Framing Systems (SFS)' },
  { value: '439', label: 'Steel Windows' },
  { value: '272', label: 'Steelwork / Metalwork' },
  { value: '45', label: 'Steeplejack' },
  { value: '57', label: 'Stick System Curtain Walling' },
  { value: '244', label: 'Stone / Marble / Granite Polishing and Restoration' },
  { value: '198', label: 'Stone Carving' },
  { value: '458', label: 'Stone Cladding' },
  { value: '163', label: 'Stone Flooring' },
  { value: '199', label: 'Stone Mason' },
  { value: '490', label: 'Stone Repairs' },
  { value: '2679', label: 'Stone Slips' },
  { value: '128', label: 'Street Furniture' },
  { value: '398', label: 'Street Lighting' },
  { value: '84', label: 'Structural Engineer' },
  { value: '176', label: 'Structural Glazing Structures' },
  { value: '2378', label: 'Structural Insulated Panels (SIPs)' },
  { value: '278', label: 'Structural Steelwork' },
  { value: '454', label: 'Stud Welding' },
  { value: '2682', label: 'Sub-White Lining' },
  { value: '570', label: 'Substation' },
  { value: '339', label: 'SUDS' },
  { value: '340', label: 'Sustainable Drainage' },
  { value: '2641', label: 'Swimming Pool' },
  { value: '572', label: 'Switchgear and Transformers' },
  { value: '2663', label: 'Syphonic Pipe Installation' },
  { value: '2626', label: 'Technology Application' },
  { value: '2467', label: 'Telemetry' },
  { value: '463', label: 'Telephone Systems' },
  { value: '2450', label: 'Temporary Compound/Site Security' },
  { value: '46', label: 'Temporary Cradles' },
  { value: '129', label: 'Temporary Fencing' },
  { value: '47', label: 'Temporary Hoists / Lifts' },
  { value: '557', label: 'Temporary Site Services' },
  { value: '85', label: 'Temporary Works Engineer / Designer' },
  { value: '48', label: 'Temporary Works Screening' },
  { value: '283', label: 'Tensile Structures' },
  { value: '164', label: 'Terrazzo Flooring' },
  { value: '270', label: 'Timber Balustrades / Handrails' },
  { value: '58', label: 'Timber Cladding' },
  { value: '106', label: 'Timber Doors' },
  { value: '165', label: 'Timber Flooring' },
  { value: '298', label: 'Timber Frames' },
  { value: '150', label: 'Timber Panelling' },
  { value: '245', label: 'Timber Repairs' },
  { value: '271', label: 'Timber Stairs' },
  { value: '107', label: 'Timber Windows' },
  { value: '2700', label: 'Tool & Plant Hire' },
  { value: '334', label: 'Topographical Survey' },
  { value: '466', label: 'Towel Rails' },
  { value: '422', label: 'Trace Heating' },
  { value: '2446', label: 'Trace Heating & Lagging' },
  { value: '425', label: 'Traction Lifts' },
  { value: '396', label: 'Traffic Management' },
  { value: '395', label: 'Traffic Signalling' },
  { value: '394', label: 'Tree Surgery - Felling' },
  { value: '393', label: 'Tree Surgery / Felling' },
  { value: '2479', label: 'Tunnelling & Shaft SInking' },
  { value: '189', label: 'Underpinning' },
  { value: '2429', label: 'Underpressure Connections/Drilling' },
  { value: '59', label: 'Unitised Curtain Walling' },
  { value: '151', label: 'Upholsterer' },
  { value: '485', label: 'uPVC Doors' },
  { value: '484', label: 'uPVC Windows' },
  { value: '2635', label: 'Utilities' },
  { value: '335', label: 'Utility Mapping' },
  { value: '2434', label: 'Utility Surveys' },
  { value: '2430', label: 'UV Equipment' },
  { value: '2418', label: 'Valves & Penstocks' },
  { value: '2651', label: 'Vehicle Restraint' },
  { value: '558', label: 'Venetian Plastering' },
  { value: '223', label: 'Ventilation' },
  { value: '451', label: 'Vinyl Flooring' },
  { value: '2445', label: 'WAC Testing' },
  { value: '177', label: 'Walk-on Glass' },
  { value: '152', label: 'Wall Panelling' },
  { value: '294', label: 'Wallpapering' },
  { value: '2367', label: 'Washrooms' },
  { value: '2431', label: 'Washwater Systems' },
  {
    value: '2421',
    label: 'Waste Water Packaged Plant (Hire of Temporary Plant)',
  },
  { value: '2432', label: 'Waste Water Packaged Plant (Humus Conical Tanks)' },
  { value: '2419', label: 'Waste Water Packaged Plant (New SAF plant)' },
  { value: '2420', label: 'Waste Water Packaged Plant (Septic Tanks)' },
  { value: '2383', label: 'Wastewater Treatment Works' },
  { value: '468', label: 'Water Heaters' },
  { value: '2381', label: 'Water Mains Installations' },
  { value: '2422', label: 'Water Tank Cleaning' },
  { value: '448', label: 'Water Testing' },
  { value: '2424', label: 'Water Treatment Technology - Media' },
  {
    value: '2423',
    label: 'Water Treatment Technology - Media (Cartridge Filters)',
  },
  { value: '2384', label: 'Water Treatment Works' },
  { value: '302', label: 'Waterproofing / Tanking' },
  { value: '2481', label: 'Waterproofing Membrane' },
  { value: '2668', label: 'Waterstorage Tanks' },
  { value: '2717', label: 'WC Cubicles' },
  { value: '279', label: 'Welding Contractors' },
  { value: '2482', label: 'Well pointing/ground water control' },
  { value: '246', label: 'Wet and Dry Rot Treatments' },
  { value: '440', label: 'Wet Underfloor Heating' },
  { value: '2712', label: 'White Lining' },
  { value: '546', label: 'Wifi / Internet Connection' },
  { value: '108', label: 'Window Film / Manifestation' },
  { value: '247', label: 'Windows Refurbishment / Repairs' },
  { value: '547', label: 'Wired / Wireless Networking' },
  { value: '153', label: 'Worktops / Countertops' },
  { value: '530', label: 'Wrought Iron' },
  { value: '258', label: 'Zinc Roofing / Cladding' },
];

export { PACKAGE_OPTIONS };
